// This file will export one constant for every action that can be performed using redux
export const SET_METHODOLOGY = 'SET_METHODOLOGY';
export const SET_SELECT_COUNTRY = 'SET_SELECT_COUNTRY';
export const SET_SELECT_COUNTRY_2 = 'SET_SELECT_COUNTRY_2';
export const SET_SELECT_COUNTRY_3 = 'SET_SELECT_COUNTRY_3';
export const SET_LOCKED_COUNTRY = 'SET_LOCKED_COUNTRY';